export const formatedPrice = (priceToFormat: number, withCurrency = true) =>
  priceToFormat.toLocaleString('ru-RU', {
    style: withCurrency ? 'currency' : undefined,
    currency: withCurrency ? 'RUB' : undefined,
    maximumFractionDigits: 0,
  });
